function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_CALLBACKS, DEFAULT_OPTIONS, KEYS } from '../shared/constants';
export default {
  name: 'v-tour',
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    name: {
      type: String
    },
    options: {
      type: Object,
      default: () => {
        return DEFAULT_OPTIONS;
      }
    },
    callbacks: {
      type: Object,
      default: () => {
        return DEFAULT_CALLBACKS;
      }
    }
  },
  data() {
    return {
      currentStep: -1
    };
  },
  mounted() {
    this.$tours[this.name] = this;
  },
  beforeDestroy() {
    // Remove the keyup listener if it has been defined
    if (this.customOptions.useKeyboardNavigation) {
      window.removeEventListener('keyup', this.handleKeyup);
    }
  },
  computed: {
    // Allow us to define custom options and merge them with the default options.
    // Since options is a computed property, it is reactive and can be updated during runtime.
    customOptions() {
      return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), this.options);
    },
    customCallbacks() {
      return _objectSpread(_objectSpread({}, DEFAULT_CALLBACKS), this.callbacks);
    },
    // Return true if the tour is active, which means that there's a VStep displayed
    isRunning() {
      return this.currentStep > -1 && this.currentStep < this.numberOfSteps;
    },
    isFirst() {
      return this.currentStep === 0;
    },
    isLast() {
      return this.currentStep === this.steps.length - 1;
    },
    numberOfSteps() {
      return this.steps.length;
    },
    step() {
      return this.steps[this.currentStep];
    }
  },
  methods: {
    async start(startStep) {
      // Register keyup listeners for this tour
      if (this.customOptions.useKeyboardNavigation) {
        window.addEventListener('keyup', this.handleKeyup);
      }

      // Wait for the DOM to be loaded, then start the tour
      startStep = typeof startStep !== 'undefined' ? parseInt(startStep, 10) : 0;
      let step = this.steps[startStep];
      let process = () => new Promise((resolve, reject) => {
        setTimeout(() => {
          this.customCallbacks.onStart();
          this.currentStep = startStep;
          resolve();
        }, this.customOptions.startTimeout);
      });
      if (typeof step.before !== 'undefined') {
        try {
          await step.before('start');
        } catch (e) {
          return Promise.reject(e);
        }
      }
      await process();
      return Promise.resolve();
    },
    async previousStep() {
      let futureStep = this.currentStep - 1;
      let process = () => new Promise((resolve, reject) => {
        this.customCallbacks.onPreviousStep(this.currentStep);
        this.currentStep = futureStep;
        resolve();
      });
      if (futureStep > -1) {
        let step = this.steps[futureStep];
        if (typeof step.before !== 'undefined') {
          try {
            await step.before('previous');
          } catch (e) {
            return Promise.reject(e);
          }
        }
        await process();
      }
      return Promise.resolve();
    },
    async nextStep() {
      let futureStep = this.currentStep + 1;
      let process = () => new Promise((resolve, reject) => {
        this.customCallbacks.onNextStep(this.currentStep);
        this.currentStep = futureStep;
        resolve();
      });
      if (futureStep < this.numberOfSteps && this.currentStep !== -1) {
        let step = this.steps[futureStep];
        if (typeof step.before !== 'undefined') {
          try {
            await step.before('next');
          } catch (e) {
            return Promise.reject(e);
          }
        }
        await process();
      }
      return Promise.resolve();
    },
    stop() {
      this.customCallbacks.onStop();
      document.body.classList.remove('v-tour--active');
      this.currentStep = -1;
    },
    skip() {
      this.customCallbacks.onSkip();
      this.stop();
    },
    finish() {
      this.customCallbacks.onFinish();
      this.stop();
    },
    handleKeyup(e) {
      if (this.customOptions.debug) {
        console.log('[Vue Tour] A keyup event occured:', e);
      }
      switch (e.keyCode) {
        case KEYS.ARROW_RIGHT:
          this.isKeyEnabled('arrowRight') && this.nextStep();
          break;
        case KEYS.ARROW_LEFT:
          this.isKeyEnabled('arrowLeft') && this.previousStep();
          break;
        case KEYS.ESCAPE:
          this.isKeyEnabled('escape') && this.stop();
          break;
      }
    },
    isKeyEnabled(key) {
      const enabledNavigationKeys = this.customOptions.enabledNavigationKeys;
      return enabledNavigationKeys.hasOwnProperty(key) ? enabledNavigationKeys[key] : true;
    }
  }
};